import { useState, ChangeEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../../service/apiPaths";
import ApiService from "../../../../../service/ApiService";
import { IAddProject } from "../../Project.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddProject = () => {
  const [formData, setFormData] = useState<IAddProject>({
    name: "",
    description: "",
    gitfeld: "",
    status: "Active",
    clientId: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [client, setClient] = useState<any[]>([]);
  const [clientId, setClientId] = useState<string>("");

  const navigate = useNavigate();
  useEffect(() => {
    clientData();
  }, []);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { id, value, name } = e.target;
    const key = id || name;
    setFormData((prev) => ({ ...prev, [key]: value }));
  };
  const clientData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getClients}`,
      });
      setClient(result);
      setClientId(result[0].id);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit: SubmitHandler<IAddProject> = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.createProject,
        data: {
          name: formData.name,
          description: formData.description,
          gitfeld: formData.gitfeld,
          status: formData.status,
          clientId: clientId,
        },
      });
      if (response !== "undefined") {
        toast.success("Project added successfully", {
          duration: 5000,
        });
        setTimeout(() => {
          navigate("/project");
        }, 1500);
      }
    } catch (error) {
      toast.error(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error adding project:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/project");
  };

  return {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleCancel,
    client,
    clientId,
    setClientId,
  };
};

export default useAddProject;
